import { Share2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButton = ({ p }) => {
  const share = async () => {
    const url = `${window.location.origin}/produto/${p.id}`;
    const data = { title: `${p.model} | RC iPhones`, text: `Olha esse ${p.model} na RC iPhones:`, url };
    if (navigator.share) {
      await navigator.share(data).catch(() => null);
      return;
    }
    await navigator.clipboard?.writeText(url).catch(() => null);
    toast.success("Link copiado! Cole no WhatsApp ou Instagram.");
  };

  return (
    <button data-testid="product-share-button" onClick={share} className="flex w-full items-center justify-center gap-2 rounded-full border border-white/20 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10">
      <Share2 className="h-4 w-4" /> Compartilhar este produto
    </button>
  );
};
